import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Otp from './otp';
import ChangePassword from './changepassword';

import {
  fetchSecurity,
  updatePassword,
  fetchMe,
  updateUser,
} from '../../actions';

class Security extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      newPassword: '',
      newPasswordConf: '',
      passwordSuccess: '',
      deviceWhitelisting: false,
    };
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, user } = this.props;

    let deviceWhitelisting;
    if (user && user.me && user.me.flags && user.me.flags.deviceWhitelisting) {
      deviceWhitelisting = user.me.flags.deviceWhitelisting;
    }
    
    this.setState({deviceWhitelisting})

    dispatch(fetchSecurity());
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handleNewPasswordChange(event) {
    this.setState({ newPassword: event.target.value });
  }

  updatePassword(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { password, newPassword, newPasswordConf } = this.state;
    const type = 'updatePassword';

    const mismatchPassword = (newPassword && newPasswordConf) && (newPassword !== newPasswordConf);

    if (mismatchPassword) {
      return;
    }

    const data = {
      password,
      newPassword,
      type,
    };
    dispatch(updatePassword(data))
      .then((res) => {
        if (res.errors) {
          this.setState({ passwordSuccess: '' });
        }
        if (!res.errors) {
          this.setState({ password: '', newPassword: '', passwordSuccess: 'Password Updated' });
          this.props.toggleModal(null);
        }
      });
  }

  handleDeviceWhitelistChange() {
    const { dispatch, user } = this.props;
    const { deviceWhitelisting } = this.state;

    const data = {
      deviceWhitelisting: !deviceWhitelisting
    }

    dispatch(updateUser(data)).then((res) => {
      if (res) dispatch(fetchMe());
    });

    this.setState({ deviceWhitelisting: !deviceWhitelisting, pristine: true });
  }

  render() {
    const { user, tempAnon } = this.props;
    const { password, newPassword, passwordSuccess, newPasswordConf, deviceWhitelisting } = this.state;

    let otpEnabled;
    let yubiEnabled;
    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    let enabled2fa;
    if (otpEnabled || yubiEnabled) {
      enabled2fa = true;
    }

    if (!user.security) {
      return null;
    }

    let passMin;
    let passCaps;
    let passNum;
    let passSpec;

    if (newPassword.length >= 8) {
      passMin = true;
    }
    if (/[A-Z]/.test(newPassword)) {
      passCaps = true;
    }
    if (/[0-9]/.test(newPassword)) {
      passNum = true;
    }
    if (/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/.test(newPassword)) {
      passSpec = true;
    }

    const mismatchPassword = (newPassword && newPasswordConf) && (newPassword !== newPasswordConf);

    const completed = password && newPassword && passMin && passCaps && passNum && passSpec && !mismatchPassword;

    const passRating = [passMin, passCaps, passNum, passSpec].filter(Boolean).length;

    return (
      <div className="cell panel v2 small-12 medium-12 large-12">
        <div className="panel-label">
          Security
        </div>
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Two-Factor Authentication</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <div>
              <div
                onClick={() => this.props.toggleModal(<Otp toggleModal={this.props.toggleModal} modalComponent={this.state.modalComponent} />)}
                className={enabled2fa ? 'vlt-switch on' : 'vlt-switch off'}
              >
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Device Whitelisting</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <div>
              <div
                onClick={() => this.handleDeviceWhitelistChange()}
                className={deviceWhitelisting ? 'vlt-switch on' : 'vlt-switch off'}
                >
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Change Password</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <a className="vlt-btn vlt-btn-outline" href="/settings/change-password">
              Change
            </a>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Login Sessions</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <a className="vlt-btn vlt-btn-outline" href="/settings/login-sessions">
              View Sessions
            </a>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Login History</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <a className="vlt-btn vlt-btn-outline" href="/settings/login-history">
              View History
            </a>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Global Lock</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <a className="vlt-btn vlt-btn-outline" href="/settings/global-lock">
              Setup
            </a>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Sign In With Ethereum</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <a className="vlt-btn vlt-btn-outline" href="/settings/sign-in-with-ethereum">
              Setup
            </a>
          </div>
        </div>
        <hr />
        <div className="grid-x align-middle">
          <div className="cell small-6 medium-6 large-6">
            <div>Device Whitelisting</div>
          </div>
          <div className="cell small-6 medium-6 large-6 flex-end">
            <a className="vlt-btn vlt-btn-outline" href="/settings/device-whitelisting">
              Setup
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  siweNonce: state.user.siweNonce,
  tempAnon: state.user.tempAnon,
  errors: state.user.errors,
});

export default connect(mapStateToProps)(Security);
